import moment from 'moment';

export const solcitationStatus = {
  open: 'Open',
};

export const verifyIsSolicitationStatusOpen = (status, dateTime) =>
  status === solcitationStatus.open &&
  moment(dateTime).isSameOrBefore(moment());
